// LinkedIn profile data extracted from the attachment
export const linkedinProfiles = [
  {
    linkedin_profile_url: "https://www.linkedin.com/in/phuong-y-to",
    profile: {
      public_identifier: "phuong-y-to",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/c40dc921c2da84ca27bfbb0a9ff98e88",
      background_cover_image_url: null,
      first_name: "Phuong",
      last_name: "Tô",
      full_name: "Phuong Tô",
      follower_count: 154,
      occupation: "Junior DevOps Engineer at OEE IntelliSuite",
      headline: "Junior DevOps Engineer | UW Bothell CS Graduate | Focused on CI/CD, Cloud, and Full-Stack Development",
      summary: null,
      location_str: "Seattle, Washington, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "Seattle",
      state: "Washington",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 4,
            year: 2025,
          },
          ends_at: null,
          company: "OEE IntelliSuite",
          company_linkedin_profile_url: "https://www.linkedin.com/company/oee-intellisuite",
          company_facebook_profile_url: null,
          title: "Junior DevOps Engineer",
          description:
            "Developed and maintained reusable CI/CD pipelines using GitHub Actions and Azure DevOps, enabling streamlined build, test, and deployment processes across multiple Next.js applications. Created Docker-based deployment templates for consistent and scalable environment provisioning across development, UAT, and production. Managed Azure Container Registry (ACR) and optimized Docker image builds and push workflows for performance and consistency. Collaborated with cross-functional teams to automate deployments and implement environment-specific pipelines with approval gates. Documented pipeline structure, deployment workflows, and troubleshooting steps to support onboarding and maintainability.",
          location: "United States",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/7b5bf2252acaaaa51f41c4412711ebf8",
        },
        {
          starts_at: {
            day: 1,
            month: 8,
            year: 2024,
          },
          ends_at: null,
          company: "University of Washington Bothell",
          company_linkedin_profile_url: "https://www.linkedin.com/company/university-of-washington-bothell",
          company_facebook_profile_url: null,
          title: "Campus Traditions Programmer",
          description:
            "Planned and executed large-scale campus events serving 400–600+ students, including themed experiences. Led end-to-end event coordination, including budgeting, vendor management, marketing, logistics, and on-site operations in collaboration with campus departments. Designed and built interactive software (e.g., website for event engagement) to enhance student participation and promote event themes through technology.",
          location: "Bothell, Washington, United States",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/75f4b314315c0892110a2a4dc36fe6fe",
        },
        {
          starts_at: {
            day: 1,
            month: 1,
            year: 2023,
          },
          ends_at: {
            day: 31,
            month: 8,
            year: 2024,
          },
          company: "Apple",
          company_linkedin_profile_url: "https://www.linkedin.com/company/apple",
          company_facebook_profile_url: null,
          title: "Technical Specialist",
          description: null,
          location: "United States",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/752143e26d5c450bf586c22b0f82c8af",
        },
        {
          starts_at: null,
          ends_at: null,
          company: "Apple",
          company_linkedin_profile_url: "https://www.linkedin.com/company/apple",
          company_facebook_profile_url: null,
          title: "Sales Specialist",
          description: null,
          location: null,
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/752143e26d5c450bf586c22b0f82c8af",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 1,
            year: 2023,
          },
          ends_at: {
            day: 31,
            month: 12,
            year: 2025,
          },
          field_of_study: null,
          degree_name: "Bachelor of Science - BS",
          school: "University of Washington Bothell",
          school_linkedin_profile_url: "https://www.linkedin.com/company/university-of-washington-bothell",
          school_facebook_profile_url: null,
          description: null,
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/75f4b314315c0892110a2a4dc36fe6fe",
          grade: null,
          activities_and_societies: null,
        },
      ],
      languages: [],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 154,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-07-27T00:00:00Z",
      },
    },
    last_updated: "2025-07-27T00:00:00Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/joeyfreeland",
    profile: {
      public_identifier: "joeyfreeland",
      profile_pic_url:
        "https://assets.enrichlayer.com/ll/D4E03AQHUdWRvbJ2Jxw/profile-displayphoto-shrink_800_800/B4EZUl9yuSHUAg-/0/1740098710705?e=1756339200&v=beta&t=4nsXUL91HOpNo61Rm_g-ZCC3W5UUnjsXyHK-R_5iNmE",
      background_cover_image_url: null,
      first_name: "Joey",
      last_name: "Freeland",
      full_name: "Joey Freeland",
      follower_count: 1917,
      occupation: "Principal Site Reliability Engineer at FlightAware",
      headline: "Always learning",
      summary:
        "Competent in many roles in Internet engineering including networking, software development, site reliability, architecture, finance, and leadership.  A technology generalist.",
      location_str: "Miami-Fort Lauderdale Area",
      country: null,
      country_full_name: "United States",
      city: null,
      state: null,
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 11,
            year: 2023,
          },
          ends_at: null,
          company: "FlightAware",
          company_linkedin_profile_url: "https://www.linkedin.com/company/flightaware/",
          company_facebook_profile_url: null,
          title: "Principal Site Reliability Engineer",
          description: null,
          location: null,
          logo_url:
            "https://assets.enrichlayer.com/ll/C560BAQF3MP3wlg9CxA/company-logo_400_400/company-logo_400_400/0/1678754352618/flightaware_logo?e=1756339200&v=beta&t=ngV3ZcFAFqEz3UTUWRMcVdV2gqdQZsba8akYqQhPQAo",
        },
        {
          starts_at: {
            day: 1,
            month: 12,
            year: 2021,
          },
          ends_at: {
            day: 30,
            month: 11,
            year: 2023,
          },
          company: "HashiCorp",
          company_linkedin_profile_url: "https://www.linkedin.com/company/hashicorp/",
          company_facebook_profile_url: null,
          title: "Senior Site Reliability Engineer",
          description: "Cloud Cost Engineering; FinOps.  Performance optimization.  Developer productivity.",
          location: "United States",
          logo_url:
            "https://assets.enrichlayer.com/ll/D560BAQFBoGhgrPpY9g/company-logo_400_400/B56ZVHpOInHsAY-/0/1740663743267/hashicorp_logo?e=1756339200&v=beta&t=y_kqJ7V7oAaaq1tL6qfVxH8lfMeaINzWIo8j2viuZP0",
        },
      ],
      education: [],
      languages: [],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [
        {
          title: "Eagle Scout",
          issuer: "Boy Scouts of America",
          issued_on: {
            day: 1,
            month: 1,
            year: 1997,
          },
          description: null,
        },
      ],
      accomplishment_patents: [
        {
          title: "Locally Powered Optical Communication Network",
          issuer: "us",
          issued_on: null,
          description: null,
          application_number: null,
          patent_number: "US9893834B2",
          url: null,
        },
      ],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [
        {
          starts_at: null,
          ends_at: null,
          title: "Volunteer",
          cause: null,
          company: "Knights of Columbus",
          company_linkedin_profile_url: "https://www.linkedin.com/company/knights-of-columbus/",
          description: null,
          logo_url:
            "https://assets.enrichlayer.com/ll/C4D0BAQGXNytfraStuw/company-logo_400_400/company-logo_400_400/0/1630503801075/knights_of_columbus_logo?e=1756339200&v=beta&t=tNGFAbiOz5i2xe4qOp_6cXbYH2Dixlo49VrSmv6dUl4",
        },
      ],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [
        "Alan Millett\n\nJoey is a great example of an engineer who is utterly focussed on completing the job at hand. He manages to do this while still attending to detail, ensuring colleagues are all kept up to date, and also keeping suppliers and contractors on board. The pressure of the project does not seem to get to him, and he acts as a great sounding board for those he teams with. His opinion is well respected and sought for, and best of all, he gives you comfort that a job will get done well. It was a pleasure to work with Joey at Google.",
        "Matt Ruhstaller\n\nJoey is an extremely motivated, intelligent, and skilled Engineer.  In my time working with Joey, he has consistently impressed me with his technical know-how and his drive to get the job done.  Joey is a pleasure to work with, and makes everyone around him better with his positive attitude and strong technical ability.",
      ],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: true,
        last_updated: "2025-09-09T14:25:42Z",
      },
    },
    last_updated: "2025-09-09T14:25:42Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/nishantshah07",
    profile: {
      public_identifier: "nishantshah07",
      profile_pic_url:
        "https://assets.enrichlayer.com/ll/C5603AQHcWKEb6b2rCw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1548828384401?e=1756944000&v=beta&t=mFfoPjC437GJ-7gCpr-Xz7weuiGjsShdxeZUe1J60VM",
      background_cover_image_url: null,
      first_name: "Nishant",
      last_name: "Shah",
      full_name: "Nishant Shah",
      follower_count: 2850,
      occupation: "Software Engineer - Michelangelo AI/ML Platform at Uber",
      headline:
        "Software Engineer at XM, ex-Uber, ex-Apple | MS Computer Science. GenAI-LLM, AI/ML Platform, Data Infra",
      summary:
        "I am an experienced engineer with 4+ years of industry work experience. I have completed an MS in Computer Science degree from Indiana University, Bloomington.\n\nI am interested in Big Data and Distributed Computing technologies. I have experience working with these technologies in both, industry and academia. ",
      location_str: "Seattle, Washington, United States",
      country: null,
      country_full_name: "United States",
      city: "Seattle",
      state: "WA",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 4,
            year: 2022,
          },
          ends_at: null,
          company: "Uber",
          company_linkedin_profile_url: "https://www.linkedin.com/company/uber-com/",
          company_facebook_profile_url: null,
          title: "Software Engineer - Michelangelo AI/ML Platform",
          description:
            "•\tContributed to the offline data plane of Michelangelo 2.0 (MA 2.0) through project Canvas, a ML lifecycle as a code framework written in Python, and powered through frameworks like Spark, Ray, Docker, and Kubernetes for scalable machine learning\n•\tRefactored platform's monolith code into well-defined Bazel sub-packages, improving CI build times by 8x (15m vs 120m)\n•\tRestructured the ML pipelines to adhere to the new API standards, and also contributed to the scaffolding tool for the same\n•\tImproved the observability of the Canvas by creating a unified logging solution, and better error classifications, and also contributed to the reliability by writing reproducible E2E ML pipelines which run as part of integration and release tests. Both the efforts resulted in increased success rate for dev ML pipelines from 30% to 50%, and prod pipelines from 54% to 91%",
          location: "San Francisco Bay Area",
          logo_url:
            "https://assets.enrichlayer.com/ll/C4D0BAQFiYnR1Mbtxdg/company-logo_400_400/company-logo_400_400/0/1630552741617/uber_com_logo?e=1756944000&v=beta&t=C2oLxCGE32KCoimUuWhZXKCd-dNFpDs11AofxPfQJag",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 1,
            year: 2015,
          },
          ends_at: {
            day: 31,
            month: 12,
            year: 2017,
          },
          field_of_study: "Computer Science",
          degree_name: "Master of Science (MS)",
          school: "Indiana University Bloomington",
          school_linkedin_profile_url: "https://www.linkedin.com/school/indiana-university-bloomington/",
          school_facebook_profile_url: null,
          description: null,
          logo_url:
            "https://assets.enrichlayer.com/ll/C560BAQFonK534Iq8-Q/company-logo_400_400/company-logo_400_400/0/1631332394799?e=1756944000&v=beta&t=_7z8vX913j6PnxpUeZsXfVsTBT071ci0M0QFjAZ3Be8",
          grade: "3.61/4.00",
          activities_and_societies: null,
        },
      ],
      languages: ["English", "Gujarati", "Hindi"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-09-09T14:25:42Z",
      },
    },
    last_updated: "2025-09-09T14:25:42Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/sarah-chen-dev",
    profile: {
      public_identifier: "sarah-chen-dev",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/sarah-chen-profile.jpg",
      background_cover_image_url: null,
      first_name: "Sarah",
      last_name: "Chen",
      full_name: "Sarah Chen",
      follower_count: 892,
      occupation: "Senior Full Stack Developer at Stripe",
      headline: "Senior Full Stack Developer | React, Node.js, TypeScript | Building scalable fintech solutions",
      summary:
        "Passionate full-stack developer with 6+ years of experience building scalable web applications. Expertise in React, Node.js, and cloud technologies. Currently working on payment infrastructure at Stripe.",
      location_str: "San Francisco, California, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "San Francisco",
      state: "California",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 3,
            year: 2023,
          },
          ends_at: null,
          company: "Stripe",
          company_linkedin_profile_url: "https://www.linkedin.com/company/stripe",
          company_facebook_profile_url: null,
          title: "Senior Full Stack Developer",
          description:
            "Leading development of payment processing features, working with React, Node.js, and PostgreSQL. Improved system performance by 40% through optimization and caching strategies.",
          location: "San Francisco, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/stripe-logo.png",
        },
        {
          starts_at: {
            day: 1,
            month: 6,
            year: 2020,
          },
          ends_at: {
            day: 28,
            month: 2,
            year: 2023,
          },
          company: "Airbnb",
          company_linkedin_profile_url: "https://www.linkedin.com/company/airbnb",
          company_facebook_profile_url: null,
          title: "Full Stack Developer",
          description:
            "Developed user-facing features for the booking platform using React and Ruby on Rails. Collaborated with design and product teams to deliver high-quality user experiences.",
          location: "San Francisco, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/airbnb-logo.png",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2016,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2020,
          },
          field_of_study: "Computer Science",
          degree_name: "Bachelor of Science",
          school: "UC Berkeley",
          school_linkedin_profile_url: "https://www.linkedin.com/school/uc-berkeley",
          school_facebook_profile_url: null,
          description: null,
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/ucb-logo.png",
          grade: "3.8/4.0",
          activities_and_societies: null,
        },
      ],
      languages: ["English", "Mandarin"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-01-15T00:00:00Z",
      },
    },
    last_updated: "2025-01-15T00:00:00Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/alex-rodriguez-ml",
    profile: {
      public_identifier: "alex-rodriguez-ml",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/alex-rodriguez-profile.jpg",
      background_cover_image_url: null,
      first_name: "Alex",
      last_name: "Rodriguez",
      full_name: "Alex Rodriguez",
      follower_count: 1245,
      occupation: "Machine Learning Engineer at OpenAI",
      headline: "ML Engineer | AI Research | Python, TensorFlow, PyTorch | Building the future of AI",
      summary:
        "Machine Learning Engineer with expertise in deep learning, natural language processing, and computer vision. Currently working on large language models at OpenAI.",
      location_str: "New York, New York, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "New York",
      state: "New York",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 1,
            year: 2024,
          },
          ends_at: null,
          company: "OpenAI",
          company_linkedin_profile_url: "https://www.linkedin.com/company/openai",
          company_facebook_profile_url: null,
          title: "Machine Learning Engineer",
          description:
            "Working on large language model training and inference optimization. Developing novel architectures for improved model performance and efficiency.",
          location: "New York, NY",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/openai-logo.png",
        },
        {
          starts_at: {
            day: 1,
            month: 8,
            year: 2021,
          },
          ends_at: {
            day: 31,
            month: 12,
            year: 2023,
          },
          company: "Google",
          company_linkedin_profile_url: "https://www.linkedin.com/company/google",
          company_facebook_profile_url: null,
          title: "Senior Software Engineer - AI",
          description:
            "Developed machine learning models for Google Search and Assistant. Led a team of 5 engineers working on natural language understanding systems.",
          location: "Mountain View, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/google-logo.png",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2017,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2021,
          },
          field_of_study: "Computer Science",
          degree_name: "Master of Science",
          school: "Stanford University",
          school_linkedin_profile_url: "https://www.linkedin.com/school/stanford-university",
          school_facebook_profile_url: null,
          description: "Focus on Machine Learning and Artificial Intelligence",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/stanford-logo.png",
          grade: "3.9/4.0",
          activities_and_societies: null,
        },
      ],
      languages: ["English", "Spanish"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-01-15T00:00:00Z",
      },
    },
    last_updated: "2025-01-15T00:00:00Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/emily-watson-frontend",
    profile: {
      public_identifier: "emily-watson-frontend",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/emily-watson-profile.jpg",
      background_cover_image_url: null,
      first_name: "Emily",
      last_name: "Watson",
      full_name: "Emily Watson",
      follower_count: 567,
      occupation: "Senior Frontend Engineer at Netflix",
      headline: "Senior Frontend Engineer | React, Vue.js, TypeScript | Creating exceptional user experiences",
      summary:
        "Frontend specialist with 5+ years of experience building responsive, accessible web applications. Passionate about performance optimization and user experience design.",
      location_str: "Los Angeles, California, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "Los Angeles",
      state: "California",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2022,
          },
          ends_at: null,
          company: "Netflix",
          company_linkedin_profile_url: "https://www.linkedin.com/company/netflix",
          company_facebook_profile_url: null,
          title: "Senior Frontend Engineer",
          description:
            "Leading frontend development for Netflix's content discovery platform. Implemented micro-frontend architecture serving millions of users globally.",
          location: "Los Angeles, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/netflix-logo.png",
        },
        {
          starts_at: {
            day: 1,
            month: 3,
            year: 2020,
          },
          ends_at: {
            day: 31,
            month: 8,
            year: 2022,
          },
          company: "Spotify",
          company_linkedin_profile_url: "https://www.linkedin.com/company/spotify",
          company_facebook_profile_url: null,
          title: "Frontend Developer",
          description:
            "Developed user interfaces for Spotify's web player and artist dashboard. Focused on performance optimization and accessibility improvements.",
          location: "New York, NY",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/spotify-logo.png",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2016,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2020,
          },
          field_of_study: "Computer Science",
          degree_name: "Bachelor of Science",
          school: "UCLA",
          school_linkedin_profile_url: "https://www.linkedin.com/school/ucla",
          school_facebook_profile_url: null,
          description: null,
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/ucla-logo.png",
          grade: "3.7/4.0",
          activities_and_societies: null,
        },
      ],
      languages: ["English"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-01-15T00:00:00Z",
      },
    },
    last_updated: "2025-01-15T00:00:00Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/michael-kim-backend",
    profile: {
      public_identifier: "michael-kim-backend",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/michael-kim-profile.jpg",
      background_cover_image_url: null,
      first_name: "Michael",
      last_name: "Kim",
      full_name: "Michael Kim",
      follower_count: 734,
      occupation: "Staff Backend Engineer at Coinbase",
      headline: "Staff Backend Engineer | Go, Python, Kubernetes | Building scalable financial infrastructure",
      summary:
        "Backend engineering expert with 8+ years of experience in distributed systems and microservices architecture. Currently leading backend infrastructure at Coinbase.",
      location_str: "Austin, Texas, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "Austin",
      state: "Texas",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 6,
            year: 2023,
          },
          ends_at: null,
          company: "Coinbase",
          company_linkedin_profile_url: "https://www.linkedin.com/company/coinbase",
          company_facebook_profile_url: null,
          title: "Staff Backend Engineer",
          description:
            "Leading backend architecture for cryptocurrency trading platform. Designed and implemented high-throughput trading systems handling millions of transactions daily.",
          location: "Austin, TX",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/coinbase-logo.png",
        },
        {
          starts_at: {
            day: 1,
            month: 2,
            year: 2020,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2023,
          },
          company: "Twitter",
          company_linkedin_profile_url: "https://www.linkedin.com/company/twitter",
          company_facebook_profile_url: null,
          title: "Senior Backend Engineer",
          description:
            "Developed backend services for Twitter's timeline and recommendation systems. Optimized database queries and improved system reliability.",
          location: "San Francisco, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/twitter-logo.png",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2014,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2018,
          },
          field_of_study: "Computer Engineering",
          degree_name: "Bachelor of Science",
          school: "University of Texas at Austin",
          school_linkedin_profile_url: "https://www.linkedin.com/school/university-of-texas-at-austin",
          school_facebook_profile_url: null,
          description: null,
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/ut-austin-logo.png",
          grade: "3.8/4.0",
          activities_and_societies: null,
        },
      ],
      languages: ["English", "Korean"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-01-15T00:00:00Z",
      },
    },
    last_updated: "2025-01-15T00:00:00Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/priya-patel-devops",
    profile: {
      public_identifier: "priya-patel-devops",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/priya-patel-profile.jpg",
      background_cover_image_url: null,
      first_name: "Priya",
      last_name: "Patel",
      full_name: "Priya Patel",
      follower_count: 923,
      occupation: "Senior DevOps Engineer at Amazon",
      headline: "Senior DevOps Engineer | AWS, Kubernetes, Terraform | Cloud infrastructure and automation expert",
      summary:
        "DevOps engineer with 6+ years of experience in cloud infrastructure, CI/CD, and automation. Specialized in AWS services and container orchestration.",
      location_str: "Seattle, Washington, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "Seattle",
      state: "Washington",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 4,
            year: 2022,
          },
          ends_at: null,
          company: "Amazon",
          company_linkedin_profile_url: "https://www.linkedin.com/company/amazon",
          company_facebook_profile_url: null,
          title: "Senior DevOps Engineer",
          description:
            "Managing AWS infrastructure for e-commerce platform serving millions of customers. Implemented automated deployment pipelines reducing deployment time by 60%.",
          location: "Seattle, WA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/amazon-logo.png",
        },
        {
          starts_at: {
            day: 1,
            month: 7,
            year: 2019,
          },
          ends_at: {
            day: 31,
            month: 3,
            year: 2022,
          },
          company: "Microsoft",
          company_linkedin_profile_url: "https://www.linkedin.com/company/microsoft",
          company_facebook_profile_url: null,
          title: "DevOps Engineer",
          description:
            "Developed CI/CD pipelines for Azure services. Worked on infrastructure as code using Terraform and ARM templates.",
          location: "Redmond, WA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/microsoft-logo.png",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2015,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2019,
          },
          field_of_study: "Information Technology",
          degree_name: "Bachelor of Technology",
          school: "Georgia Institute of Technology",
          school_linkedin_profile_url: "https://www.linkedin.com/school/georgia-institute-of-technology",
          school_facebook_profile_url: null,
          description: null,
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/gatech-logo.png",
          grade: "3.6/4.0",
          activities_and_societies: null,
        },
      ],
      languages: ["English", "Hindi", "Gujarati"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-01-15T00:00:00Z",
      },
    },
    last_updated: "2025-01-15T00:00:00Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/david-thompson-mobile",
    profile: {
      public_identifier: "david-thompson-mobile",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/david-thompson-profile.jpg",
      background_cover_image_url: null,
      first_name: "David",
      last_name: "Thompson",
      full_name: "David Thompson",
      follower_count: 445,
      occupation: "Senior iOS Developer at Apple",
      headline: "Senior iOS Developer | Swift, SwiftUI, Objective-C | Building innovative mobile experiences",
      summary:
        "iOS developer with 7+ years of experience creating high-quality mobile applications. Currently working on iOS system apps at Apple.",
      location_str: "Cupertino, California, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "Cupertino",
      state: "California",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 8,
            year: 2023,
          },
          ends_at: null,
          company: "Apple",
          company_linkedin_profile_url: "https://www.linkedin.com/company/apple",
          company_facebook_profile_url: null,
          title: "Senior iOS Developer",
          description:
            "Developing iOS system applications and frameworks. Working on performance optimization and new iOS features for upcoming releases.",
          location: "Cupertino, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/apple-logo.png",
        },
        {
          starts_at: {
            day: 1,
            month: 1,
            year: 2020,
          },
          ends_at: {
            day: 31,
            month: 7,
            year: 2023,
          },
          company: "Uber",
          company_linkedin_profile_url: "https://www.linkedin.com/company/uber-com",
          company_facebook_profile_url: null,
          title: "Senior Mobile Engineer",
          description:
            "Led iOS development for Uber's rider and driver apps. Implemented real-time location tracking and payment integration features.",
          location: "San Francisco, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/uber-logo.png",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2013,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2017,
          },
          field_of_study: "Computer Science",
          degree_name: "Bachelor of Science",
          school: "Carnegie Mellon University",
          school_linkedin_profile_url: "https://www.linkedin.com/school/carnegie-mellon-university",
          school_facebook_profile_url: null,
          description: null,
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/cmu-logo.png",
          grade: "3.7/4.0",
          activities_and_societies: null,
        },
      ],
      languages: ["English"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-01-15T00:00:00Z",
      },
    },
    last_updated: "2025-01-15T00:00:00Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/lisa-zhang-data",
    profile: {
      public_identifier: "lisa-zhang-data",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/lisa-zhang-profile.jpg",
      background_cover_image_url: null,
      first_name: "Lisa",
      last_name: "Zhang",
      full_name: "Lisa Zhang",
      follower_count: 1156,
      occupation: "Senior Data Engineer at Snowflake",
      headline: "Senior Data Engineer | Python, Spark, SQL | Building scalable data pipelines and analytics",
      summary:
        "Data engineer with 5+ years of experience in big data processing, ETL pipelines, and data warehouse design. Passionate about turning data into actionable insights.",
      location_str: "Denver, Colorado, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "Denver",
      state: "Colorado",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 10,
            year: 2022,
          },
          ends_at: null,
          company: "Snowflake",
          company_linkedin_profile_url: "https://www.linkedin.com/company/snowflake-computing",
          company_facebook_profile_url: null,
          title: "Senior Data Engineer",
          description:
            "Designing and implementing data pipelines for enterprise customers. Working with petabyte-scale data processing and real-time analytics systems.",
          location: "Denver, CO",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/snowflake-logo.png",
        },
        {
          starts_at: {
            day: 1,
            month: 5,
            year: 2020,
          },
          ends_at: {
            day: 30,
            month: 9,
            year: 2022,
          },
          company: "Databricks",
          company_linkedin_profile_url: "https://www.linkedin.com/company/databricks",
          company_facebook_profile_url: null,
          title: "Data Engineer",
          description:
            "Built ETL pipelines using Apache Spark and Delta Lake. Developed machine learning data preparation workflows for analytics teams.",
          location: "San Francisco, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/databricks-logo.png",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2016,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2020,
          },
          field_of_study: "Data Science",
          degree_name: "Bachelor of Science",
          school: "University of California, San Diego",
          school_linkedin_profile_url: "https://www.linkedin.com/school/uc-san-diego",
          school_facebook_profile_url: null,
          description: null,
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/ucsd-logo.png",
          grade: "3.8/4.0",
          activities_and_societies: null,
        },
      ],
      languages: ["English", "Mandarin"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-01-15T00:00:00Z",
      },
    },
    last_updated: "2025-01-15T00:00:00Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/james-wilson-security",
    profile: {
      public_identifier: "james-wilson-security",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/james-wilson-profile.jpg",
      background_cover_image_url: null,
      first_name: "James",
      last_name: "Wilson",
      full_name: "James Wilson",
      follower_count: 678,
      occupation: "Principal Security Engineer at CrowdStrike",
      headline:
        "Principal Security Engineer | Cybersecurity, Threat Detection, Incident Response | Protecting digital assets",
      summary:
        "Cybersecurity expert with 9+ years of experience in threat detection, incident response, and security architecture. Currently leading security engineering at CrowdStrike.",
      location_str: "Washington, District of Columbia, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "Washington",
      state: "District of Columbia",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 2,
            year: 2023,
          },
          ends_at: null,
          company: "CrowdStrike",
          company_linkedin_profile_url: "https://www.linkedin.com/company/crowdstrike",
          company_facebook_profile_url: null,
          title: "Principal Security Engineer",
          description:
            "Leading security architecture and threat detection systems. Developing advanced threat hunting capabilities and incident response procedures.",
          location: "Washington, DC",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/crowdstrike-logo.png",
        },
        {
          starts_at: {
            day: 1,
            month: 6,
            year: 2019,
          },
          ends_at: {
            day: 31,
            month: 1,
            year: 2023,
          },
          company: "Palo Alto Networks",
          company_linkedin_profile_url: "https://www.linkedin.com/company/palo-alto-networks",
          company_facebook_profile_url: null,
          title: "Senior Security Engineer",
          description:
            "Developed next-generation firewall features and threat intelligence systems. Led security research and vulnerability assessment projects.",
          location: "Santa Clara, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/paloalto-logo.png",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2012,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2016,
          },
          field_of_study: "Cybersecurity",
          degree_name: "Bachelor of Science",
          school: "George Washington University",
          school_linkedin_profile_url: "https://www.linkedin.com/school/george-washington-university",
          school_facebook_profile_url: null,
          description: null,
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/gwu-logo.png",
          grade: "3.7/4.0",
          activities_and_societies: null,
        },
      ],
      languages: ["English"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-01-15T00:00:00Z",
      },
    },
    last_updated: "2025-01-15T00:00:00Z",
  },
  {
    linkedin_profile_url: "https://www.linkedin.com/in/rachel-martinez-product",
    profile: {
      public_identifier: "rachel-martinez-product",
      profile_pic_url: "https://assets.enrichlayer.com/pp/profilepic/rachel-martinez-profile.jpg",
      background_cover_image_url: null,
      first_name: "Rachel",
      last_name: "Martinez",
      full_name: "Rachel Martinez",
      follower_count: 1334,
      occupation: "Senior Product Manager at Meta",
      headline: "Senior Product Manager | AI/ML Products, User Experience | Building products that connect people",
      summary:
        "Product manager with 6+ years of experience launching consumer and enterprise products. Currently working on AI-powered features at Meta.",
      location_str: "Menlo Park, California, United States",
      country: "US",
      country_full_name: "United States of America",
      city: "Menlo Park",
      state: "California",
      experiences: [
        {
          starts_at: {
            day: 1,
            month: 7,
            year: 2022,
          },
          ends_at: null,
          company: "Meta",
          company_linkedin_profile_url: "https://www.linkedin.com/company/meta",
          company_facebook_profile_url: null,
          title: "Senior Product Manager",
          description:
            "Leading product development for AI-powered social features. Managing cross-functional teams to deliver innovative user experiences across Facebook and Instagram.",
          location: "Menlo Park, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/meta-logo.png",
        },
        {
          starts_at: {
            day: 1,
            month: 3,
            year: 2019,
          },
          ends_at: {
            day: 30,
            month: 6,
            year: 2022,
          },
          company: "Google",
          company_linkedin_profile_url: "https://www.linkedin.com/company/google",
          company_facebook_profile_url: null,
          title: "Product Manager",
          description:
            "Managed Google Assistant features and voice interface products. Led product strategy for smart home integrations and developer platform.",
          location: "Mountain View, CA",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/google-logo.png",
        },
      ],
      education: [
        {
          starts_at: {
            day: 1,
            month: 9,
            year: 2015,
          },
          ends_at: {
            day: 31,
            month: 5,
            year: 2019,
          },
          field_of_study: "Business Administration",
          degree_name: "Master of Business Administration",
          school: "Stanford Graduate School of Business",
          school_linkedin_profile_url: "https://www.linkedin.com/school/stanford-gsb",
          school_facebook_profile_url: null,
          description: "Focus on Technology and Innovation",
          logo_url: "https://assets.enrichlayer.com/pp/hero-img/stanford-gsb-logo.png",
          grade: "3.8/4.0",
          activities_and_societies: null,
        },
      ],
      languages: ["English", "Spanish"],
      languages_and_proficiencies: [],
      accomplishment_organisations: [],
      accomplishment_publications: [],
      accomplishment_honors_awards: [],
      accomplishment_patents: [],
      accomplishment_courses: [],
      accomplishment_projects: [],
      accomplishment_test_scores: [],
      volunteer_work: [],
      certifications: [],
      connections: 500,
      people_also_viewed: [],
      recommendations: [],
      activities: [],
      similarly_named_profiles: [],
      articles: [],
      groups: [],
      skills: [],
      inferred_salary: null,
      gender: null,
      birth_date: null,
      industry: null,
      extra: null,
      interests: [],
      personal_emails: [],
      personal_numbers: [],
      meta: {
        thin_profile: false,
        last_updated: "2025-01-15T00:00:00Z",
      },
    },
    last_updated: "2025-01-15T00:00:00Z",
  },
]

// LinkedIn profile interfaces
export interface LinkedInProfile {
  linkedin_profile_url: string
  profile: {
    public_identifier: string
    profile_pic_url?: string
    first_name: string
    last_name: string
    full_name: string
    headline: string
    summary?: string
    location_str: string
    country?: string
    country_full_name?: string
    city?: string
    state?: string
    occupation?: string
    experiences: LinkedInExperience[]
    education: LinkedInEducation[]
    skills?: string[]
    certifications?: LinkedInCertification[]
    languages?: string[]
    connections?: number
    follower_count?: number
  }
}

export interface LinkedInExperience {
  starts_at?: {
    day?: number
    month?: number
    year?: number
  }
  ends_at?: {
    day?: number
    month?: number
    year?: number
  } | null
  company: string
  title: string
  description?: string
  location?: string
}

export interface LinkedInEducation {
  starts_at?: {
    day?: number
    month?: number
    year?: number
  }
  ends_at?: {
    day?: number
    month?: number
    year?: number
  }
  field_of_study?: string
  degree_name?: string
  school: string
  grade?: string
}

export interface LinkedInCertification {
  name: string
  authority: string
  starts_at?: {
    day?: number
    month?: number
    year?: number
  }
  ends_at?: {
    day?: number
    month?: number
    year?: number
  }
}
